module.exports = __webpack_public_path__ + "static/media/ic_ticket_board_gray.138c7434.svg";